import Button from "@/components/Button";
import Column from "@/components/Column";
import Columns from "@/components/Columns";
import Form from "@/components/Form";
import Layout from "@/components/Layout";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";
import TypeProductForm from "@/components/TypeProduct";
import { useTypeProduct } from "./hooks/useTypeProduct";
import ShortFlowLayout from "@/components/ShortFlow/ShortFlowLayout";

export function TypeProductPage() {
  const {
    handleOnSubmit,
    typeProductSelected,
    setTypeProductSelected,
    onClickForwardButton,
    pageConfig,
    isSpeedFlow,
  } = useTypeProduct();

  const SelectedLayout = isSpeedFlow ? ShortFlowLayout : Layout;

  return (
    <SelectedLayout>
      <SEO
        title="Tipo do P"
        description="Adicione os dados pessoais do titular da conta para continuar comprando seu plano TIM!"
      />
      <Column size={12}>
        <PageHeader
          title="Olá! Escolha o produto!"
          dataIcTitle="sec-omega-comunicacao"
        />
      </Column>
      <Columns
        as={Form}
        className="pt-3"
        alignItems="start"
        justifyContent="center"
        onSubmit={handleOnSubmit}
      >
        <Column size={12}>
          <TypeProductForm
            typeProductSelected={typeProductSelected}
            setTypeProductSelected={setTypeProductSelected}
          />
        </Column>

        <Column size={12}>
          <Button
            type="submit"
            large
            onClick={() => {
              onClickForwardButton();
            }}
          >
            {isSpeedFlow ? "Finalizar" : "Continuar"}
          </Button>
        </Column>
        <Column size={12} className="mt-8">
          <Button
            type="button"
            kind="secondary"
            large
            to={pageConfig.prevRoute}
          >
            Voltar
          </Button>
        </Column>
      </Columns>
    </SelectedLayout>
  );
}

export default TypeProductPage;
